import { formatPathQuery } from ".";

// 导航工具函数，避免循环依赖
let routerInstance: any = null;

export const setRouterInstance = (router: any) => {
  routerInstance = router;
};

export const navigateTo = (path: string) => {
  if (routerInstance) {
    routerInstance.navigate(path);
  } else {
    // 如果 router 实例还没有设置，使用原生导航
    window.location.href = path;
  }
};

export const replaceTo = (path: string) => {
  if (routerInstance) {
    routerInstance.navigate(path, { replace: true });
  } else {
    // 如果 router 实例还没有设置，使用原生导航
    window.location.replace(path);
  }
};

export const navigateBack = () => {
  if (routerInstance) {
    routerInstance.navigate(-1);
  } else {
    window.history.back();
  }
};

// 跳转协议 pdf
export const navigateToAgreement = (query: {url: string, isCanvas?: string}) => {
  const url = formatPathQuery('/agreement', {
    url: encodeURIComponent(query.url),
    isCanvas: query.isCanvas,
  });
  navigateTo(url);
};